import "@/styles/packages.scss"

import { register } from "../helpers/stimulus"

import { setupAccordions } from "@/components/content/Accordion"

import CarouselController from "../controllers/carousel_controller"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import OldVoucherFormController from "../controllers/old_voucher_form_controller"
import TooltipController from "../controllers/tooltip_controller"
import VoucherFormController from "../controllers/voucher_form_controller"

const NEW_PACKAGE_PAGE = document.body.getAttribute("data-new-package-page") === "true"

const setupStimulus = (): void => {
  if (NEW_PACKAGE_PAGE) {
    register("carousel", CarouselController)
    register("package-details-modal", ModalController)
    register("package-details-modal-trigger", ModalTriggerController)
    register("voucher-form", VoucherFormController)
  } else {
    register("disclosure-item", DisclosureItemController)
    register("facilities-modal", ModalController)
    register("facilities-modal-trigger", ModalTriggerController)
    register("old-voucher-form", OldVoucherFormController)
    register("tooltip", TooltipController)
  }

  register("voucher-form", VoucherFormController)
}

setupStimulus()
setupAccordions()
